import Reflux from "reflux";
import * as Immutable from "immutable";
import SharedEntity from "logic/permissions/SharedEntity";
import ApiRoutes from "routing/ApiRoutes";
import fetch from "logic/rest/FetchProvider";
import EntityShareState from "logic/permissions/EntityShareState";
import EntityShareActions from "actions/permissions/EntityShareActions";
import { qualifyUrl } from "util/URLUtils";
import { singletonStore } from "logic/singleton";
import PaginationURL from "util/PaginationURL";
const DEFAULT_PREPARE_PAYLOAD = {};
const formatPaginatedSharesResponse = ({
  additional_queries: additionalQueries,
  context,
  count,
  entities,
  page,
  per_page: perPage,
  query,
  total
}) => ({
  list: Immutable.List(entities.map((se) => SharedEntity.fromJSON(se))),
  context: {
    granteeCapabilities: context.grantee_capabilities
  },
  pagination: {
    additionalQueries,
    page,
    perPage,
    query,
    count,
    total
  }
});
const EntityShareStore = singletonStore(
  "permissions.EntityShare",
  () => Reflux.createStore({
    listenables: [EntityShareActions],
    state: void 0,
    getInitialState() {
      return this._state();
    },
    prepare(_entityType, _entityTitle, entityGRN, payload = DEFAULT_PREPARE_PAYLOAD) {
      const url = entityGRN ? ApiRoutes.EntityShareController.prepare(entityGRN).url : ApiRoutes.EntityShareController.prepareEntityCreate().url;
      const promise = fetch("POST", qualifyUrl(url), JSON.stringify(payload)).then(this._handleResponse);
      EntityShareActions.prepare.promise(promise);
      return promise;
    },
    update(_entityType, _entityTitle, entityGRN, payload) {
      const url = qualifyUrl(ApiRoutes.EntityShareController.update(entityGRN).url);
      const promise = fetch("POST", url, JSON.stringify(payload)).then(this._handleResponse);
      EntityShareActions.update.promise(promise);
      return promise;
    },
    loadUserSharesPaginated(userId, { page, perPage, query, additionalQueries }) {
      const url = PaginationURL(
        ApiRoutes.EntityShareController.userSharesPaginated(userId).url,
        page,
        perPage,
        query,
        additionalQueries
      );
      const promise = fetch("GET", qualifyUrl(url)).then(formatPaginatedSharesResponse);
      EntityShareActions.loadUserSharesPaginated.promise(promise);
      return promise;
    },
    _handleResponse(entityShareStateJSON) {
      const entityShareState = EntityShareState.fromJSON(entityShareStateJSON);
      this.state = entityShareState;
      this._trigger();
      return this.state;
    },
    _state() {
      return {
        state: this.state
      };
    },
    _trigger() {
      this.trigger(this._state());
    }
  })
);
export { EntityShareStore, EntityShareActions };
export default EntityShareStore;
